import { atom } from "jotai";
import useApi, { ApiStatus, emptyApiState } from "src/hooks/api/utils/useApi";

const searchAtom = atom<any>(emptyApiState);

type State = {
	searches: any[];
	detail: any;
	status: ApiStatus;
	actions: {
		set: (state: any) => any;
		search: (search: string) => Promise<any>;
		getDetails: (id: string) => Promise<any>;
	};
};

function useCompanyInfoSearch(): State {
	const { state, actions } = useApi(searchAtom, {
		baseUrl: `/helpers/company-info`,
		query: {},
	});

	const getSearch = async (search: string) => {
		actions.list({
			search,
		});
	};

	const getDetails = async (id: string) => {
		return actions.get(id);
	};

	return {
		searches: state?.list,
		detail: state?.data,
		status: state.status,
		actions: {
			set: actions.set,
			search: getSearch,
			getDetails,
		},
	};
}

export default useCompanyInfoSearch;
